"use strict";
require('bootstrap/dist/css/bootstrap.min.css');
require('bootstrap/dist/css/bootstrap-theme.min.css');
require('bootstrap-select/dist/css/bootstrap-select.min.css');
require('bootstrap-select/dist/js/bootstrap-select.min.js');
var $ = require('jquery');
var _ = require('lodash');
var Promise = require('bluebird');
window["$"] = $;
window["jQuery"] = $;
window["_"] = _;
window["Promise"] = Promise;
require('../externalLibs/bootstrap-3.3.4.min.js');
window["bootbox"] = require('../externalLibs/bootbox.min.js');
require('../externalLibs/jquery.ba-bbq.min.js');
require('../externalLibs/fastclick.min.js');
require('../externalLibs/typeahead.jquery.min.js');
require('../externalLibs/bootstrap-datepicker.min.js');



/*****************
 ** WEBPACK FOOTER
 ** ./src/externalLibs.ts
 ** module id = 0
 ** module chunks = 0
 **/